import React from 'react';
import {
  Form, Row, Col, Input, Select, Button,Icon
} from 'antd';
import img from "./../../../assets/img/Illustration.png";
const { Option } = Select;
class FD extends React.Component {
  handleSubmit = (e) => {
    e.preventDefault();
    let { question } = this.props;

    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.submitHandler({ ...values, zip: values.zip, id: question?question.id:0 }, (val) => {
          if (!val) {
          }

        });
      }
    });

  }
  constructor(props) {
    super(props);
    this.state = {
      ismailingaddselect: false,

    }
  }
  selectAdd = (val, lab) => {
    if (lab && lab.props.children.trim() === "Mailing Address") {
      this.setState({
        ismailingaddselect: true
      })
    } else {
      this.setState({
        ismailingaddselect: false
      })
    }
  }

  // componentDidMount(){
  // const { setFieldsValue } = this.props.form;
  // this.setFieldsValue({
  //   country: 'United States'
  // })
// }
componentDidMount = () => {
  const { setFieldsValue } = this.props.form;
  let { question } = this.props;

   if(question)
    setTimeout(() => {
      setFieldsValue({
        abbr: question.abbr, question: question.question, question_Description: question.question_Description
      });
    }, 100);
};
  render() {
    const { getFieldDecorator } = this.props.form;
    let { states } = this.props;
    return (
      <div className="mi_model_popup">
        <Row span={24}>
          <Col span={18}>
            <p  style={{marginLeft:"15px"}} className='mi_title'>{this.props.title}</p>
          </Col>
          <Col span={6}>
            <i className="fa fa-times mi_icon mi_icon_red mi_button_close" style={{ color: 'red' }} onClick={this.props.closeDrawerHandler} ></i>
          </Col>
        </Row>
        <Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>
          <Row span={24}>


          <Col sm={24}>
          <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">State</legend>
                  {getFieldDecorator('abbr', {
                    rules: [{ required: true, message: 'Please select State' }, {

                    }],
                  })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                    optionFilterProp="children"
                    showSearch={true}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    placeholder="Please Select State"
                  >
                   {states.map(tag => <Option value={tag.code} key={tag.code}>{tag.name}</Option>)}


                  </Select>)}
                </fieldset>
              </Form.Item>

            </Col>

          <Col sm={24}>
              <Form.Item>
                <fieldset style={{ height: 'auto' }} className="mi_input_pop">
                  <legend className="legend-font">Question</legend>
                  {getFieldDecorator('question', {
                    rules: [{ required: true, message: 'Please enter Question.' },

                    ],
                  })(<Input.TextArea type="text" style={{ height: '100px' }} autoComplete={"nope"}  className="mi_input" placeholder="Enter Question" />)}
                </fieldset>
              </Form.Item>

            </Col>

            <Col sm={24}>
              <Form.Item>
                <fieldset style={{ height: 'auto' }} className="mi_input_pop">
                  <legend className="legend-font">Question Description</legend>
                  {getFieldDecorator('question_Description', {
                    rules: [{ required: false, message: 'Please enter Question Description.' },

                    ],
                  })(<Input.TextArea type="text" style={{ height: '100px' }} autoComplete={"nope"}  className="mi_input" placeholder="Enter Question Description" />)}
                </fieldset>
              </Form.Item>

            </Col>




          </Row>
          <Row span={24} style={{ marginTop: '20px' }}>
            <Col span={7} ></Col>
            <Col span={5} >
              <Button className="mi_button_right submit-button" onClick={this.props.closeDrawerHandler} style={{ marginRight: 8 }}>
                Cancel
              </Button>
            </Col>
            <Col span={5} >
              <Button htmlType="submit"  className="submit-button" type="primary" >
                Submit
              </Button>
            </Col>
           <Col span={7} >
              <img alt="example" style={{ width: 105, marginBottom: '-28px', float: 'right' }} src={img} />
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}
const StateSpecificQuestion = Form.create()(FD);
export default StateSpecificQuestion;